import { Input, Form, Button, message, Col, Row, Select } from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useCallback } from "react";
import { useEffect } from "react";
import { adicionarAntena } from "../../../../store/antenaActions";
import { setStatusNull } from "../../../../store/actions";
import { IFazendaList } from "../../../../reducers/FazendaReducer";
import { IStore } from "../../../../store";
import { IStatusList } from "../../../../store/types";
import { IServidorList } from "../../../../reducers/ServidorReducer";
import { ISafraModule } from "../../../../reducers/SafraReducer";

const { Option } = Select;

interface PropsAddAntena {
    status: IStatusList;
    fazendaList: IFazendaList;
    servidorList: IServidorList;

    adicionarAntena: Function;
    setStatusNull: Function;

    setModal: Function;
    server: any;
}

function AdicionarAntena(props: PropsAddAntena) {
    const {
        status,
        adicionarAntena,
        setStatusNull,
        fazendaList,
        servidorList,
    } = props;
    const [form] = Form.useForm();

    const [nome, setNome] = useState("");
    const [validoNome, setValidoNome] = useState(false);
    const [validoIdGat, setValidoIdGat] = useState(false);

    const [validoProfileGat, setProfileGat] = useState(true);
    const [validoIdService, setValidoIdService] = useState(true);

    const [validoServer, setValidoServer] = useState(false);

    const handleDisable = useCallback(() => {
        if (
            validoNome === true &&
            validoIdGat === true &&
            validoIdService === true &&
            validoProfileGat === true
        ) {
            return false;
        }
        return true;
    }, [
        validoNome,
        validoIdGat,
        validoServer,
        validoProfileGat,
        validoIdService,
    ]);

    useEffect(() => {
        if (status.antena?.add?.success) {
            props.setModal(false);
            setStatusNull("add", "antena");
        }
    });

    return (
        <>
            <Form
                form={form}
                layout="vertical"
                onFinish={v => {
                    adicionarAntena(v);
                }}
                initialValues={{ local_server_temp: props.server }}
            >
                <div style={{ display: "none" }}>
                    {/* <Form.Item name="coordenadas">
                        <Input type="hidden" />
                    </Form.Item> */}
                    <Form.Item name="local_server_temp">
                        <Input type="hidden" />
                    </Form.Item>
                </div>

                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="Nome da antena:"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: "Use apenas letras.",
                                    pattern: new RegExp(/^[a-zA-Z-/-/]+$/),
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return (
                                                setValidoNome(false),
                                                Promise.reject(
                                                    "Coloque um Nome."
                                                )
                                            );
                                        }
                                        setValidoNome(true);
                                        setNome(value);
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="ID do Gateway:"
                            name="gateway_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Coloque um Id.",
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return (
                                                setValidoIdGat(false),
                                                Promise.reject()
                                            );
                                        }
                                        setValidoIdGat(true);
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input placeholder="Digite o ID do Gateway" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[24, 0]}>
                    <Col span={12}>
                        {" "}
                        <Form.Item
                            name="gateway_profile_id"
                            label="Gateway Profile:"
                            rules={[
                                {
                                    required: true,
                                    message: "Coloque um Id do Gateway.",
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return (
                                                setProfileGat(false),
                                                Promise.reject()
                                            );
                                        }
                                        setProfileGat(true);
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input placeholder="Digite o id do gateway profile" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        {" "}
                        <Form.Item
                            name="service_profile_id"
                            label="ID do Service:"
                            rules={[
                                {
                                    required: true,
                                    message: "Coloque um Id do Service.",
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return (
                                                setValidoIdService(false),
                                                Promise.reject()
                                            );
                                        }
                                        setValidoIdService(true);
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input placeholder="Digite o id do service" />
                        </Form.Item>
                    </Col>
                </Row>

                <div style={{ marginTop: "20px" }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        disabled={handleDisable()}
                        onClick={() =>
                            form.setFieldsValue({
                                nome:
                                    nome.trim().replace(/ /g, "-") + "-gateway",
                            })
                        }
                        loading={status.antena?.add?.loading}
                    >
                        Salvar antena
                    </Button>
                </div>
            </Form>
        </>
    );
}

function mapStateToProps(store: IStore) {
    return {
        status: store.loader,
        fazendaList: store.fazendas,
        servidorList: store.servidores,
    };
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators(
        {
            adicionarAntena,
            setStatusNull,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdicionarAntena);
